import { atom } from 'jotai';

import { IAsset } from '@core';

import { swingsAtom } from './activity';

export const activeSwingIdAtom = atom<string>((get) => {
    const swings = get(swingsAtom);
    return swings[0]?.uuid;
});

export const swingImagesAtom = atom<IAsset[]>();
